import { Controller } from "@hotwired/stimulus"

// Cloudflare Turnstile with explicit rendering, Turbo-compatible
// (docs/autenticacio.md). Goes on the <form>; the submit target stays
// disabled until the widget hands over a token.
//
//   <form data-controller="turnstile" data-turnstile-sitekey-value="...">
//     <div data-turnstile-target="widget"></div>
//     <button type="submit" data-turnstile-target="submit" disabled>...</button>
//   </form>
export default class extends Controller {
  static values = {
    sitekey: String,
    action: { type: String, default: "" },
    theme: { type: String, default: "auto" },
    size: { type: String, default: "flexible" },
    appearance: { type: String, default: "interaction-only" },
    failedMessage: String
  }

  static targets = ["widget", "submit", "error"]

  connect() {
    this.widgetId = null
    this.renderWidget()
  }

  disconnect() {
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = null
    }
  }

  renderWidget() {
    if (!window.turnstile) {
      // The api.js script (layout, defer) may not have loaded yet
      setTimeout(() => this.renderWidget(), 100)
      return
    }

    this.widgetId = window.turnstile.render(this.widgetTarget, {
      sitekey: this.sitekeyValue,
      action: this.actionValue || undefined,
      theme: this.themeValue,
      size: this.sizeValue,
      appearance: this.appearanceValue,
      "response-field-name": "cf-turnstile-response",
      callback: () => this.onSuccess(),
      "error-callback": () => this.onError(),
      "expired-callback": () => this.onExpired()
    })
  }

  onSuccess() {
    if (this.hasSubmitTarget) this.submitTarget.removeAttribute("disabled")
    if (this.hasErrorTarget) this.errorTarget.classList.add("hidden")
  }

  onError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = this.failedMessageValue
      this.errorTarget.classList.remove("hidden")
    }
  }

  onExpired() {
    if (this.hasSubmitTarget) this.submitTarget.setAttribute("disabled", "")
  }
}
